
export default {
	openDatabase() {
		let db = api.require('db');
		return new Promise((resolve, reject) => {
			db.openDatabase({
				name: 'main'
			}, function (ret) {
				if (ret.status) {
                    resolve(true)
                } else {
                    reject(false)
                }
            })
		})
	},
	closeDatabase() {
		let db = api.require('db');
		return new Promise((resolve,reject) =>{
			db.closeDatabase({
				name:'main'
			}, function (ret, err) {
                if (ret.status) {
                    resolve(true);
                } else {
                    reject(err);
                }
            })
		})
	},
	executeSql(sql) {
		let db = api.require('db');
		return new Promise((resolve,reject) =>{
			db.executeSql({
				name: 'main',
				sql: sql
			}, function(ret, err) {
                if (ret.status) {
                    resolve(ret);
                } else {
                    reject(err);
                }
            });
		})
	},
    selectSql(sql) {
		let db = api.require('db');
		return new Promise((resolve,reject) =>{
			db.selectSql({
				name: 'main',
				sql: sql
			}, function(ret, err) {
                if (ret.status) {
                    resolve(ret);
                } else {
                    reject(err);
                }
            });
		})
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/db.js